import React from 'react';
import card1 from '../media3/UnlockDifferent/card1.png';
import card2 from '../media3/UnlockDifferent/card2.png';
import icon1 from '../media3/UnlockDifferent/icon1.svg';
import icon2 from '../media3/UnlockDifferent/icon2.svg';

const UnlockDifferent = () => {
  return (
    <section className="unlock-section">
      <div className="unlock-container">
        {/* Header */}
        <div className="unlock-header">
          <span className="unlock-badge">Why Choose SkinForge</span>
          <h1 className="unlock-title">Unlock What Makes SkinForge Different</h1>
          <p className="unlock-subtitle">
            Experience the next level of skin trading — fast, secure, and built for gamers.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="feature-cards">
          <div className="feature-card">
            <div className="card-glow card-glow-left"></div>
            <img src={card1} alt="Feature 1" />
          </div>
          <div className="feature-card">
            <div className="card-glow card-glow-right"></div>
            <img src={card2} alt="Feature 2" />
          </div>
        </div>

        {/* Statistics Section */}
        <div className="stats-container">
          <div className="stats-header">
            <span className="stats-badge">Proven Results</span>
            <p className="stats-subtitle">The numbers are lookin' good</p>
          </div>
          
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-card">
                <div className="stat-number">
                  <span className="stat-value">68</span>
                  <span className="stat-unit">%</span>
           
                  <img src={icon1} alt="Icon" />
                </div>
                <p className="stat-description">
                  Respond to 68% more customer messages in the first year.
                </p>
              </div>
            </div>

            <div className="stat-item">
              <div className="stat-card">
                <div className="stat-number">
                  <span className="stat-value">1</span>
                  <span className="stat-unit">min</span>
           
                  <img src={icon2} alt="Icon" />
                </div>
                <p className="stat-description">
                  Less than 1 minute it takes to grab your next skin.
                </p>
              </div>
            </div>

            <div className="stat-item">
              <div className="stat-card">
                <div className="stat-number">
                  <span className="stat-value">94</span>
                  <span className="stat-unit">%</span>
      
                  <img src={icon1} alt="Icon" />
                </div>
                <p className="stat-description">
                  Players say SkinForge makes buying skins faster and safer.
                </p>
              </div>
            </div>

            <div className="stat-item">
              <div className="stat-card">
                <div className="stat-number">
                  <span className="stat-value">40</span>
                  <span className="stat-unit">%</span>
           
                  <img src={icon2} alt="Icon" />
                </div>
                <p className="stat-description">
                  Of users return weekly to explore new drops.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UnlockDifferent;